/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Twap order update request
 */
export interface TwapOrderUpdateRequest {
  /**
   * In base or quote asset. Depends from \'baseAsset\' flag
   */
  quantity: number;
  /**
   * Start execution time.
   */
  startTime: string;
  /**
   * Mode type.
   */
  modeType: TwapOrderUpdateRequest.ModeTypeEnum;
  /**
   * Finish execution time. Depends from Mode type.
   */
  finishTime?: string;
  /**
   * In seconds. Min is 1 second. Depends from Mode type..
   */
  tradesDelay: number;
  /**
   * Asset is the same like in \'quantity\' field. Depends from Mode type.
   */
  childTradeQuantity: number;
  /**
   * Percentage deviation from delay. 1 is +/- 1 percent.
   */
  randomTradesDelayPercent: number;
  /**
   * Percentage deviation from child quantity. 1 is +/- 1 percent.
   */
  randomTradesQuantity: number;
  /**
   * In 0.1 bps. Degree of aggression at an order price
   */
  slippageTolerance: number;
  /**
   * In 0.1 bps. Maximum allowable spread.
   */
  maxAcceptableSpread: number;
  /**
   * Min allowable price.
   */
  minPrice: number;
  /**
   * Max allowable price.
   */
  maxPrice: number;
  twapOrderId: number;
}
export namespace TwapOrderUpdateRequest {
  export const ModeTypeEnum = {
    DelayAndChildTradeQuantity: 'DELAY_AND_CHILD_TRADE_QUANTITY',
    FinishTimeAndDelay: 'FINISH_TIME_AND_DELAY',
    FinishTimeAndChildTradeQuantity: 'FINISH_TIME_AND_CHILD_TRADE_QUANTITY',
  } as const;
  export type ModeTypeEnum = (typeof ModeTypeEnum)[keyof typeof ModeTypeEnum];
}
